import { render, staticRenderFns } from "./ThePart2Main.vue?vue&type=template&id=9bea6776&scoped=true"
import script from "./ThePart2Main.vue?vue&type=script&lang=js"
export * from "./ThePart2Main.vue?vue&type=script&lang=js"
import style0 from "./ThePart2Main.vue?vue&type=style&index=0&id=9bea6776&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bea6776",
  null
  
)

export default component.exports